import { createStyles, WithStyles, withStyles } from '@freighthub/silhouette-core'
import { inject, observer } from 'mobx-react'
import { Component } from 'react'
import { RootStore } from 'service/RootStore'
import { UIStore } from 'service/UIStore'
import { i18n, I18nInterface } from 'utils/localisation'
import { Loader } from 'view/Loader'

const jssPageLoader = () =>
  createStyles({
    root: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
  })

interface IPageLoaderInject {
  uiStore: UIStore
}

interface IPageLoaderProps extends I18nInterface, Partial<IPageLoaderInject>, WithStyles<typeof jssPageLoader, false> {}

class LeanPageLoader extends Component<IPageLoaderProps> {
  getMessage = (i) => {
    // @ts-expect-error TS(2339) FIXME: Property 'translate' does not exist on type 'Local... Remove this comment to see the full error message
    const { translate } = this.props.localisationStore
    const messages = [
      translate('quote_loader-message-1'),
      translate('quote_loader-message-2'),
      translate('quote_loader-message-3'),
      translate('quote_loader-message-4'),
      translate('quote_loader-message-5'),
      translate('quote_loader-message-6'),
      translate('quote_loader-message-7'),
      translate('quote_loader-message-8'),
      translate('quote_loader-message-9'),
    ]
    return messages[i]
  }

  render() {
    const { classes } = this.props
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const { isLoading, showText, textIndex } = this.props.uiStore.loader

    return (
      <Loader show={isLoading} showText={showText} text={this.getMessage(textIndex)} page className={classes.root} />
    )
  }
}

const injector = inject(
  (ctx: RootStore): IPageLoaderInject => ({
    uiStore: ctx.uiStore,
  })
)

export const PageLoader = withStyles(jssPageLoader)(injector(i18n(observer(LeanPageLoader))))
